import { render, staticRenderFns } from "./ProfileSelect2ActiveList.vue?vue&type=template&id=5aeb9b0b"
import script from "./ProfileSelect2ActiveList.vue?vue&type=script&lang=js"
export * from "./ProfileSelect2ActiveList.vue?vue&type=script&lang=js"
import style0 from "./ProfileSelect2ActiveList.vue?vue&type=style&index=0&id=5aeb9b0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports